/** Matches a tray row: 40px thumbnail plus `py-1.5`. */
export const MAIN_SIDE_NAV_OVERLAY_TRAY_LIST_ITEM_ESTIMATED_HEIGHT = 52;

/** Section title `min-h-7` plus `pb-1.5` under the header. */
export const MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_HEADER_ESTIMATED_HEIGHT = 34;

/** Former tray `gap-2` between a preceding block and the next section. */
export const MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_GAP = 8;
